import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SplashIntro from "@/components/SplashIntro";
import HomePage from "@/pages/HomePage";
import NewsListPage from "@/pages/NewsListPage";
import NewsDetailPage from "@/pages/NewsDetailPage";
import { AdminAuthProvider } from "@/admin/AdminAuthContext";
import AdminLoginPage from "@/admin/AdminLoginPage";
import RequireAdmin from "@/admin/RequireAdmin";
import AdminLayout from "@/admin/AdminLayout";
import AdminDashboard from "@/admin/AdminDashboard";
import AdminArticles from "@/admin/AdminArticles";
import AdminSubscribers from "@/admin/AdminSubscribers";
import AdminContacts from "@/admin/AdminContacts";
import AdminNewsletterSend from "@/admin/AdminNewsletterSend";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

function PublicShell({ children }) {
  return (
    <>
      <SplashIntro />
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function AppShell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <AdminLayout />
            </RequireAdmin>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="articles" element={<AdminArticles />} />
          <Route path="subscribers" element={<AdminSubscribers />} />
          <Route path="contacts" element={<AdminContacts />} />
          <Route path="newsletter" element={<AdminNewsletterSend />} />
        </Route>
      </Routes>
    );
  }

  return (
    <PublicShell>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/actualites" element={<NewsListPage />} />
        <Route path="/actualites/:slug" element={<NewsDetailPage />} />
      </Routes>
    </PublicShell>
  );
}

export default function App() {
  return (
    <div className="min-h-screen bg-[#f7f5f0] text-[#0f172a] font-sans antialiased">
      <BrowserRouter>
        <AdminAuthProvider>
          <AppShell />
        </AdminAuthProvider>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          classNames: {
            toast:
              "rounded-none border border-[#0a192f]/10 bg-white text-[#0a192f]",
          },
        }}
      />
    </div>
  );
}
